import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { ResultSignVneidPopupComponent } from '../result-sign-vneid-popup/result-sign-vneid-popup.component';
import { VNeIDVerifyingModalComponent } from './components/vneid-verifying-modal/vneid-verifying-modal.component';
import { PopupFaceMathEkycComponent } from './popup-face-math-ekyc/popup-face-math-ekyc.component';
import { DocumentService } from 'src/app/core/services/document.service';

export interface EnterIdentityVneidComponent {
  /** Mã định danh (số CCCD) hiển thị sẵn, cho phép sửa nếu cần */
  identityNumber: string;
}

@Component({
  selector: 'app-enter-identity-vneid',
  templateUrl: './enter-identity-vneid.component.html',
  styleUrls: ['./enter-identity-vneid.component.scss']
})
export class EnterIdentityVneidComponent implements OnInit, OnDestroy {
  /** Bước hiện tại: 1 = Cung cấp thông tin, 2 = Xác minh thông tin */
  currentStep = 0;
  identityNumber: string;
  transactionId: string;
  encryptFaceImage: string;
  documentId: string;
  dataCheckVneid: any;
  nonce: string = '';
  sdkLicence: string = '';
  isEkyc: boolean = false;
  countdown = 60;
  private countdownInterval: any;
  tempEnterprise: any;
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    public dialogRef: MatDialogRef<EnterIdentityVneidComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EnterIdentityVneidComponent,
    private documentMohaService: DocumentMohaService,
    private documentService: DocumentService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private message: Message,
  ) {
    this.documentId = data.documentId || '';
    this.dataCheckVneid = data.dataCheckVneid;
    this.identityNumber = this.dataCheckVneid.certificateNoCCCD || '';
    this.isEkyc = this.data.isEkyc;
    this.tempEnterprise = data.tempEnterprise;
  }

  startCountdown(): void {
    this.stopCountdown();

    this.countdown = this.dataCheckVneid.timeWaitShare;
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.stopCountdown();
      }
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  ngOnInit(): void {
    this.getNonceCode();
    this.getSdkLicence();
  }

  onlyNumber(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, '');
  
    input.value = value;
    this.identityNumber = value;
  }

  getNonceCode() {
    this.documentMohaService.getNonceCode().subscribe(res => {
      if (res.success && res.data) {
        this.nonce = res.data.nonce;
      }
    })
  }
  getSdkLicence() {
    this.documentService.getApparamInfo({code: 'licence_SDK_C06'}).subscribe(res => {
      if(res.data.value){
        this.sdkLicence = res.data.value
      }
    })
  }

  /** Nút "Quay lại" - đóng popup, trả về false */
  onBack(): void {
    if (this.currentStep === 0) {
      this.dialogRef.close(false);
    } else {
      this.currentStep = 0;
    }
  }

  /** Nút "Tiếp tục" - trả về mã định danh để component cha xử lý bước xác minh tiếp theo */
  onContinue(): void {
    if (this.currentStep === 0) {
      if (this.identityNumber.length < 12) {
        this.toastr.error(this.message.getMessage('kyc.cccd_12_digits_only'));
        return
      }
      try {
        this.blockUI.start();
        if (this.dataCheckVneid.typeVerify === 'FACE_MATCH') {
          this.documentMohaService.shareInfoBiometricVneid(this.identityNumber, true).pipe(
            finalize(() => {
              this.blockUI.stop();
            })
            ).subscribe(res => {
            if (res.success) {
              const dialogEkyc = this.dialog.open(PopupFaceMathEkycComponent, {
                width: '800px',
                data: {
                  dataCheckVneid: this.dataCheckVneid,
                  nonce: this.nonce,
                  sdkLicence: this.sdkLicence,
                }
              });
              dialogEkyc.afterClosed().subscribe(rs => {
                if (rs) {  
                  this.documentMohaService.shareInfoBiometricVneid(this.identityNumber).pipe(
                    finalize(() => {
                      this.blockUI.stop();
                    })
                    ).subscribe(rss => {
                    if (rss.success) {
                      this.transactionId = rss.data.data.txnId;
                      this.currentStep = 1;
                      this.startCountdown();
                    } else {
                      this.toastr.error(rss.message);
                    }
                  })
                } 
              })
            } else {
              this.toastr.error(res.message);
            }
          })
        } else {
          this.documentMohaService.shareInfoVneid(this.identityNumber).pipe(
            finalize(() => {
              this.blockUI.stop();
            })
            ).subscribe(res => {
            if (res.success) {
              this.currentStep = 1;
              this.startCountdown();
              this.transactionId = res.data.data.txnId;
            } else {
              this.toastr.error(res.message);
            }
          })
        }
      
      } catch (error) {
        this.toastr.error(error.message)
      }
     
    } else {
      const data = {
        title: this.message.getMessage('kyc.verifying_data'),
        description:
        this.message.getMessage('kyc.the_system_checking'),
      }
      const dialogRef = this.dialog.open(VNeIDVerifyingModalComponent, {
        width: '400px',
        disableClose: true,
        autoFocus: false,
        ariaLabel: data.title,
        data,
      });
      this.encryptFaceImage = this.documentMohaService.encryptFaceImage.getValue();
      if (this.isEkyc) {
        if (this.tempEnterprise) {
          const body = {
            transactionId: this.transactionId,
            enterpriseUpdateInfoDTO: this.tempEnterprise,
            type: this.dataCheckVneid.typeVerify,
            encryptFaceImage: this.dataCheckVneid.typeVerify === 'FACE_MATCH' ? this.encryptFaceImage : null
          }
          this.documentMohaService.kycVerifyAndUpdateVneid(body).pipe(
            finalize(() => {
              dialogRef.close()
            })
            ).subscribe(res => {
              this.handleResultVneid(res, dialogRef);
          })
        } else {
          if (this.dataCheckVneid.typeVerify === 'FACE_MATCH') {
            this.documentMohaService.faceMatchAuthenVerify(this.transactionId, this.documentId, this.encryptFaceImage).pipe(
              finalize(() => {
                dialogRef.close()
              })
              ).subscribe(res => {
                this.handleResultVneid(res, dialogRef);
            })
          } else {
            this.documentMohaService.kycShareInfoVneid(this.transactionId).pipe(
              finalize(() => {
                dialogRef.close()
              })
              ).subscribe(res => {
                this.handleResultVneid(res, dialogRef);
            })
          }
        }
      } else {
        if (this.dataCheckVneid.typeVerify === 'FACE_MATCH') {
          this.documentMohaService.faceMatchSignVerify(this.transactionId, this.documentId, this.encryptFaceImage).pipe(
            finalize(() => {
              dialogRef.close()
            })
            ).subscribe(res => {
              this.handleResultVneid(res, dialogRef);
          })
        } else {
          this.documentMohaService.verifiSignVneid(this.transactionId, this.documentId).pipe(
            finalize(() => {
              dialogRef.close()
            })
            ).subscribe(res => {
              this.handleResultVneid(res, dialogRef);
          })
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  formatCountdown(totalSeconds: number): string {
    const value = Math.max(0, Math.floor(totalSeconds || 0));
  
    const minutes = Math.floor(value / 60);
    const seconds = value % 60;
  
    const minuteText = minutes < 10 ? '0' + minutes : String(minutes);
    const secondText = seconds < 10 ? '0' + seconds : String(seconds);
  
    return minuteText + ':' + secondText + 's';
  }

  handleResultVneid(res: any, dialogRef: any) {
    dialogRef.close()
    let dataDialog = {
      type: '',
      title: '',
      message: '',
    }
    if (res.success) {
      dataDialog = {
        type: 'SUCCESS',
        title: this.message.getMessage('kyc.verification_success'),
        message: this.message.getMessage('kyc.verification_success_message'),
      }
    } else {
      dataDialog = {
        type: 'ERROR',
        title: res.code == '-4' ? this.message.getMessage('kyc.notification') : this.message.getMessage('kyc.verification_failed'),
        message: res.message,
      }
    }
    const dialogSignDone = this.dialog.open(ResultSignVneidPopupComponent, {
      width: '400px',
      data: dataDialog
    });
    dialogSignDone.afterClosed().subscribe(rs => {
      if (rs) {
        this.dialogRef.close(true);
      } else {
        if (res.code != '-4') {
          this.currentStep = 0;
        }
      }
    })
  }
}